"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _map = require("rxjs/operators/map");

var _AdsActions = require("../actions/AdsActions");

var _NotificationActions = require("ReduxMessenger/actions/NotificationActions");

var connectAccountErrorNotificationEpic = function connectAccountErrorNotificationEpic($action) {
  return $action.ofType(_AdsActions.AdsActionTypes.SHOW_CONNECT_ACCOUNT_ERROR_NOTIFICATION).pipe((0, _map.map)(function (action) {
    var payload = action.payload;
    return (0, _NotificationActions.postNotification)({
      id: 'CONNECT_ACCOUNT_ERROR_NOTIFICATION',
      type: 'danger',
      titleText: payload.title,
      message: payload.body
    });
  }));
};

var _default = connectAccountErrorNotificationEpic;
exports.default = _default;
module.exports = exports.default;